import { render, staticRenderFns } from "./TextColorType.vue?vue&type=template&id=a128dcd8"
import script from "./TextColorType.vue?vue&type=script&lang=js"
export * from "./TextColorType.vue?vue&type=script&lang=js"
import style0 from "./TextColorType.vue?vue&type=style&index=0&id=a128dcd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports